// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: window.SERVER_DATA.REACT_APP_FIREBASE_API_KEY,
  authDomain: window.SERVER_DATA.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: window.SERVER_DATA.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: window.SERVER_DATA.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: window.SERVER_DATA.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: window.SERVER_DATA.REACT_APP_FIREBASE_APP_ID,
  measurementId: window.SERVER_DATA.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();
export const fbProvider = new FacebookAuthProvider();
// fbProvider.addScope("public_profile, email");
export const auth = getAuth(app);

export default app;
